import React, { useState } from "react";
import {
    Box,
    MenuItem,
    Grid,
    Table,
    Select,
    TextField,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Avatar,
    IconButton
} from "@mui/material";
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from "@mui/icons-material/Delete";

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
const UserActivityTable = ({ setClamDetails, rows, enableLoadMore, onLoadMore, setEnableApproveBtn }) => {
    const [filters, setFilters] = useState([]);
    const [selectAll, setSelectAll] = useState(false)

    const filterOptions = [
        { value: "totalVideos", label: "Total Videos" },
        { value: "todayActivity", label: "Today Activity" },
        { value: "lastSevenDayActivity", label: "Last 7-Day Activity" },
        { value: "lastFiftenDayActivity", label: "Last 15-Day Activity" },
        { value: "lastOneMonthActivity", label: "Last 1-Month Activity" },
        { value: "allActivity", label: "All Activity" },
    ];

    const [data, setData] = useState([
        { id: 1, totalVideos: 15, todayActivity: 10, allActivity: 100 },
        { id: 2, totalVideos: 20, todayActivity: 25, allActivity: 150 },
        { id: 3, totalVideos: 8, todayActivity: 5, allActivity: 50 },
    ]);
    const [filteredData, setFilteredData] = useState(data);

    const applyFilters = async () => {
        const payload = filters.reduce((acc, { filterKey, operator, input }) => {
            acc[filterKey] = input;
            acc[`${filterKey}Operation`] = operator;
            return acc;
        }, {});
        console.log("API Payload:", payload);

        // Mock API Call:
        // Assuming we fetch filtered data from an API:
        // const response = await fetch("/api/filter-data", {
        //     method: "POST",
        //     headers: { "Content-Type": "application/json" },
        //     body: JSON.stringify(payload),
        // });
        // const result = await response.json();
        // setFilteredData(result);
    };

    const addFilter = () => {
        setFilters([...filters, { filterKey: "", operator: "=", input: "" }]);
    };

    const removeFilter = (index) => {
        const updatedFilters = filters.filter((_, i) => i !== index);
        setFilters(updatedFilters);
    };

    const updateFilter = (index, key, value) => {
        const updatedFilters = [...filters];
        updatedFilters[index][key] = key === "input" ? Number(value) : value;
        console.log(updatedFilters)
        setFilters(updatedFilters);
    };

    const availableFilterKeys = filterOptions.filter(
        (option) => !filters.some((filter) => filter.filterKey === option.value)
    );

    return (
        <Box sx={{ padding: 2 }}>
            {/* <h3>Filters</h3> */}
            <Grid container spacing={2}>
                {filters.map((filter, index) => (
                    <Grid item xs={12} md={6} key={index}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <Select
                                value={filter.filterKey || ""}
                                onChange={(e) => updateFilter(index, "filterKey", e.target.value)}
                                displayEmpty
                                fullWidth
                            >
                                <MenuItem value="" disabled>
                                    Select Field
                                </MenuItem>
                                {availableFilterKeys.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                            <Select
                                value={filter.operator}
                                onChange={(e) => updateFilter(index, "operator", e.target.value)}
                                fullWidth
                            >
                                <MenuItem value="=">=</MenuItem>
                                <MenuItem value="<">&lt;</MenuItem>
                                <MenuItem value=">">&gt;</MenuItem>
                                <MenuItem value="<=">&lt;=</MenuItem>
                                <MenuItem value=">=">&gt;=</MenuItem>
                            </Select>
                            <TextField
                                type="number"
                                value={filter.input}
                                onChange={(e) => updateFilter(index, "input", e.target.value)}
                                fullWidth
                                placeholder="Value"
                            />
                            <IconButton onClick={() => removeFilter(index)} color="error">
                                <DeleteIcon />
                            </IconButton>
                        </Box>
                    </Grid>
                ))}
            </Grid>
            {/* <Box marginTop={2}>
                <Button
                    variant="outlined"
                    onClick={addFilter}
                    disabled={availableFilterKeys.length === 0}
                    sx={{ marginRight: 1 }}
                >
                    Add Filter
                </Button>
                <Button variant="contained" onClick={applyFilters}>
                    Apply Filters
                </Button>
            </Box> */}
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell><Checkbox {...label} checked={selectAll} onChange={(e) => {
                                let tempArray = [...rows];
                                for (let i = 0; i < tempArray?.length; i++) {
                                    tempArray[i].selectForApproval = e?.target?.checked; // Set all rows to true
                                }
                                setClamDetails(tempArray); // Update clamDetails with modified tempArray
                                setSelectAll(e?.target?.checked);
                                setEnableApproveBtn(e?.target?.checked)
                            }}
                            /></TableCell>
                            <TableCell>Username</TableCell>
                            <TableCell>Profile</TableCell>
                            <TableCell>Total Videos</TableCell>
                            <TableCell>Today Activity</TableCell>
                            <TableCell>Last 7 Days Activity</TableCell>
                            <TableCell>Last 15 Days Activity</TableCell>
                            <TableCell>Last One Month Activity</TableCell>
                            <TableCell>All Activity</TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell><Checkbox {...label} checked={row?.selectForApproval ? true : false} onChange={(e) => {
                                    let tempArray = [...rows];
                                    tempArray[index].selectForApproval = e?.target?.checked; // Set all rows to true
                                    setClamDetails(tempArray); // Update clamDetails with modified tempArray
                                    for (let i = 0; i < tempArray?.length; i++) {
                                        if (tempArray[i]?.selectForApproval) {
                                            setEnableApproveBtn(tempArray[i]?.selectForApproval)
                                            break;
                                        }
                                    }
                                }} /></TableCell>
                                <TableCell>{row.userName}</TableCell>
                                <TableCell>
                                    <Avatar src={row.profile} alt={row.userName} />
                                </TableCell>
                                <TableCell>{row.totalVideos}</TableCell>
                                <TableCell>{row.todayActivityTime}</TableCell>
                                <TableCell>{row.lastSevenDayActivityTime}</TableCell>
                                <TableCell>{row.lastFifteenDayActivityTime}</TableCell>
                                <TableCell>{row.lastOneMonthDayActivityTime}</TableCell>
                                <TableCell>{row.completeActivityTime}</TableCell>
                                <TableCell>{row.allActivity}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {!enableLoadMore ? <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
                <Button variant="contained" onClick={onLoadMore}>
                    Load More
                </Button>
            </Box> : <></>}

        </Box>
    );
};

export default UserActivityTable;

// Usage Example
// const rows = [
//   {
//     username: "GSK",
//     profileImage: "path/to/image.jpg",
//     totalVideos: "35k",
//     todayActivity: "10k Watch",
//     last7DayActivity: "20k Watch",
//     allActivity: "50K Watch",
//   },
// ];

// <UserActivityTable rows={rows} onLoadMore={() => console.log("Load more clicked")} />
